<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top">
    <div class="container">
      <router-link class="navbar-brand d-flex align-items-center fw-bold" to="/" style="color: #C89D43;">
        <img src="@/assets/logo.png" alt="Logo" class="me-2 logo">56yellowrosesLLC
      </router-link>

      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false"aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse justify-content-center" id="navbarNavAltMarkup">
        <div class="navbar-nav">
          <router-link class="nav-link" to="/" exact>Home</router-link>
          <router-link class="nav-link" to="/about">About</router-link>
          <router-link class="nav-link" to="/products">Products</router-link>
          <router-link class="nav-link" to="/contact">Contact</router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
};
</script>

<style scoped>
.navbar {
  font-family: "Poppins", sans-serif;
}

.logo {
  width: 65px;
  height: auto;
}

.nav-link {
  color: #c89d43 !important;
  font-weight: 600;
  font-size: 1.15rem;
  transition: color 0.3s ease, transform 0.2s ease;
  position: relative;
  margin: 0 0.8rem;
  padding-bottom: 6px;
}

.nav-link:hover {
  color: #b0842d !important;
  transform: translateY(-2px);
}

.router-link-active {
  color: #c89d43 !important;
}

.router-link-active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #c89d43;
  border-radius: 2px;
}

@media (max-width: 992px) {
  .nav-link {
    margin: 0.5rem 0;
    text-align: center;
    font-size: 1.1rem;
  }
}
</style>
